export const slugify = (text) => {
    if (!text) return '';
    return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')     // Replace spaces with -
        .replace(/[^\w-]+/g, '')     // Remove all non-word chars
        .replace(/--+/g, '-');       // Replace multiple - with single -
};

export const getAdLink = (ad) => {
    if (!ad) return '#';
    if (ad.vendorSlug && ad.adSlug) {
        return `/${ad.vendorSlug}/${ad.adSlug}`;
    }
    return `/ad/${ad.id}`;
};

export const formatWhatsAppNumber = (phone) => {
    if (!phone) return '';
    // Remove all non-numeric characters
    let cleaned = phone.replace(/\D/g, '');

    // If it starts with 0 (Sri Lanka local format), replace with 94
    if (cleaned.startsWith('0')) {
        cleaned = '94' + cleaned.substring(1);
    }
    // If it's a 9-digit number, prepend 94
    else if (cleaned.length === 9) {
        cleaned = '94' + cleaned;
    }

    return cleaned;
};
